import {
  ActivityChangeOptions,
  ActivityUserItem,
} from '@spotify/plugin-confidence-activity-react';
import { createFlagUpdatesChangeExtension } from '@spotify/plugin-confidence-flags-react';

const OwnerUpdates = ({ change }: ActivityChangeOptions) => {
  return (
    <ActivityUserItem
      oldValue={
        typeof change.oldValue === 'string' ? change.oldValue : undefined
      }
      newValue={
        typeof change.newValue === 'string' ? change.newValue : undefined
      }
    />
  );
};

export const FLAG_OWNER_CHANGE_EXTENSION = createFlagUpdatesChangeExtension({
  id: 'flag-owner-change',
  priority: 1,
  predicate: ({ change }) => change.fieldPath === '/owner',
  title: () => 'Transferred ownership',
  render: OwnerUpdates,
});
